import { render } from "./index.vue?vue&type=template&id=af9a014a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=af9a014a&lang=scss"

import exportComponent from "D:\\前端交接\\project\\project\\赛事\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__